import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { AlertesService } from 'src/app/shared/alertes.service';
import { FormulaireService } from '../../formulaire.service';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { ModeRenduService } from '../../mode-rendu/mode-rendu.service';
import { SaisieService } from '../../saisie.service';
import { Modalite, ModalitesService } from 'src/app/core/modalites.service';

@Component({
  selector: 'bis-donnees-generales',
  templateUrl: './donnees-generales.component.html',
  styleUrls: ['./donnees-generales.component.css']
})
export class DonneesGeneralesComponent implements OnInit, OnDestroy {
  @Input()
  erreursMap: Map<string, string>;
  private subTel: Subscription;
  private subTab: Subscription[] = [];
  private modalites: Modalite[] = [];
  private subscriptions: Subscription[] = [];
  public libelleJuridiction: string = '';

  public infobulleTotaux: string = 'Le bouton "Calcul Totaux" constitue un outil d\'aide à la saisie. \
    Attention à ne pas l\'utiliser si vous saisissez directement un total sans saisir toutes les valeurs détails,\
    sinon le total que vous avez saisi sera écrasé par le recalcul déclenché par le clic sur le bouton de calcul...';

  constructor(
    private formulaireService: FormulaireService,
    public alertesService: AlertesService,
    public modeRendu: ModeRenduService,
    public saisieService: SaisieService,
    public modaliteService: ModalitesService
  ) { }

  ngOnInit(): void {
    // Recherche libelle juridiction pour affichage dans le textarea de DG
    this.subscriptions.push(
      this.modaliteService.getModalites('ielstLibelleLg').subscribe(modalites => {
        this.modalites = modalites;
        // Après la mise à jour des modalités, on met à jour la valeur au cas où
        this.libelleJuridiction = this.saisieService.gestionLibelle(this.identifiantJuridictionValeur, this.modalites);
        this.formulaire.get('xxAssoNom').setValue(this.libelleJuridiction);
      })
    );
    this.subscriptions.push(
      this.juridiction.valueChanges.pipe(distinctUntilChanged()).subscribe((identifiantJuridiction) => {
        this.libelleJuridiction = this.saisieService.gestionLibelle(identifiantJuridiction, this.modalites);
        this.formulaire.get('xxAssoNom').setValue(this.libelleJuridiction);
      })
    );

    // Gestion tel avec indicatif, on gere les 3 formats pour le json car le formatage est enleve à l'affichage 
    // mais pas dans le json en cas de modification de saisie
    this.subTel = this.formulaire.get('xxIndicTel').valueChanges.pipe(distinctUntilChanged(), debounceTime(100)).subscribe(valeur => {
      if (valeur === '1' || valeur === '2') {
          this.formulaire.get('xxContactTel').setValue(this.formulaire.get('xxContactTel').value.substring(0,6));
      } else if (valeur === '3') {
        this.formulaire.get('xxContactTel').setValue(this.formulaire.get('xxContactTel').value.substring(0,8));
      } else {
        this.formulaire.get('xxContactTel').setValue(this.formulaire.get('xxContactTel').value.substring(0,10));
      }
    });
    this.formulaire.get('xxIndicTel').updateValueAndValidity();


    // Gestion du filtre des 2 onglets F et G sur les BAV
    this.formulaire.get('xxBavNb').valueChanges.pipe(debounceTime(100))
    .subscribe(valeur => {
    if (valeur === null || valeur === 0) {
      // il faut tout désactiver
      this.formulaireService.getRootForm().get('bav').disable();
      this.formulaireService.getRootForm().get('syntheseBav').disable();
    }  else {
      // il faut tout réactiver
      this.formulaireService.getRootForm().get('bav').enable();
      this.formulaireService.getRootForm().get('syntheseBav').enable();
    }
    });
    this.formulaire.get('xxBavNb').updateValueAndValidity();

    //Calcul des totaux automatiques X2
      //Calcul Total xxPremContactVictTot : on regarde que les 2 details ne bougent pas sinon on somme
      this.saisieService.calculTotal2_detail(this.formulaire, this.subTab, 'xxPremContactVictTot', 'xxPremContactRecuVict', 'xxPremContactNrecuVict');
      this.saisieService.calculTotal2_detail(this.formulaire, this.subTab, 'xxPremContactVictTot', 'xxPremContactNrecuVict', 'xxPremContactRecuVict');

      //Calcul Total xxContactVictTot : on regarde que les 2 details ne bougent pas sinon on somme
      this.saisieService.calculTotal2_detail(this.formulaire, this.subTab, 'xxContactVictTot', 'xxRecuVict', 'xxPremContactNrecuVict');
      this.saisieService.calculTotal2_detail(this.formulaire, this.subTab, 'xxContactVictTot', 'xxPremContactNrecuVict', 'xxRecuVict');

      //Calcul Total xxPremContactNvictTot : on regarde que les 2 details ne bougent pas sinon on somme
      this.saisieService.calculTotal2_detail(this.formulaire, this.subTab, 'xxPremContactNvictTot', 'xxPremContactRecuNvict', 'xxPremContactNrecuNvict');
      this.saisieService.calculTotal2_detail(this.formulaire, this.subTab, 'xxPremContactNvictTot', 'xxPremContactNrecuNvict', 'xxPremContactRecuNvict');

      //Calcul Total xxContactNvictTot : on regarde que les 2 details ne bougent pas sinon on somme
      this.saisieService.calculTotal2_detail(this.formulaire, this.subTab, 'xxContactNvictTot', 'xxRecuNvict', 'xxPremContactNrecuNvict');
      this.saisieService.calculTotal2_detail(this.formulaire, this.subTab, 'xxContactNvictTot', 'xxPremContactNrecuNvict', 'xxRecuNvict');

      //Calcul Total xxPremContactTot : on regarde que les 2 details ne bougent pas sinon on somme
      this.saisieService.calculTotal2_detail(this.formulaire, this.subTab, 'xxPremContactTot', 'xxPremContactVictTot', 'xxPremContactNvictTot');
      this.saisieService.calculTotal2_detail(this.formulaire, this.subTab, 'xxPremContactTot', 'xxPremContactNvictTot', 'xxPremContactVictTot');

      //Calcul Total xxContactTot : on regarde que les 2 details ne bougent pas sinon on somme
      this.saisieService.calculTotal2_detail(this.formulaire, this.subTab, 'xxContactTot', 'xxContactVictTot', 'xxContactNvictTot');
      this.saisieService.calculTotal2_detail(this.formulaire, this.subTab, 'xxContactTot', 'xxContactNvictTot', 'xxContactVictTot');
  }

  ngOnDestroy(): void {
    if (this.subTel) {
      this.subTel.unsubscribe();
    }
    if (this.subTab.length !== 0) {
      this.subTab.forEach(element => element.unsubscribe());
    }
    if (this.subscriptions.length !== 0) {
      this.subscriptions.forEach(element => element.unsubscribe());
    }
  }

  /**
   * Permet de récupérer le formulaire principal
   */
  public get rootForm(): UntypedFormGroup {
    return this.formulaireService.getRootForm() as UntypedFormGroup;
  }

  /**
   * Permet de récupérer le formulaire de l’onglet considéré
   */
  public get formulaire(): UntypedFormGroup {
    return this.formulaireService.getRootForm().get('dg') as UntypedFormGroup;
  }

  public get xxIndicTel(): string {
    return this.formulaire.get('xxIndicTel').value;
  }
 
  public calculTotalTableauDG1() {
      //Calcul Total xxRecuTot 
      this.saisieService.calculTotal2(this.formulaire, 'xxRecuTot', 'xxRecuVict', 'xxRecuNvict');

      //Calcul Total xxPremContactRecuTot 
      this.saisieService.calculTotal2(this.formulaire, 'xxPremContactRecuTot', 'xxPremContactRecuVict', 'xxPremContactRecuNvict');

      //Calcul Total xxPremContactNrecuTot 
      this.saisieService.calculTotal2(this.formulaire, 'xxPremContactNrecuTot', 'xxPremContactNrecuVict', 'xxPremContactNrecuNvict');
  }

  get juridiction(): UntypedFormControl {
    if (this.rootForm.get('ielst')) {
      return this.rootForm.get('ielst') as UntypedFormControl;
    } else {
      console.error('Impossible de trouver la juridiction pour l\'afficher dans DG');
      return null;
    }
  }

  get identifiantJuridictionValeur(): string {
    return this.juridiction.value;
  }

}
